export default "__VITE_ASSET__1f63b07c__"